<template>
    <div class="reo-select rel" ref="select" @mouseover="showArea = true" @mouseout="showArea = false">
        <p :class="['reo-select-inner', {'hover': showArea}]">
            <span>{{selectedLabel}}<span class="ui-icon icon-icon_down-2"></span></span>
            <i class="border-gradient ui-gradient-blue"></i>
        </p>
        <div class="reo-select-wrap" v-show="showArea" :style="{
            'left': left,
            'transform': left === '50%' ? 'translateX(-50%)' : 'none'
        }">
            <ul class="reo-select-option" :style="{'width': width}">
                <i class="border-gradient ui-gradient-blue"></i>
                <li v-for="( option, key ) in options"
                :key="key"
                :value="option.value"
                :class="[ selectedValue === option.value ? 'active' : '' ]"
                v-on:click="updateValue( option )"
                >
                    <span>
                        <slot name="prefix" :option="option"></slot>
                        {{ option.label }}{{ option.status === 'unbound' ? `(${$t('unbound')})` : '' }}
                    </span>
                </li>
            </ul>
            <div class="select-shadow-area" v-show="showArea" :style="{
                'top': `0px`
            }" @click="showArea = false"></div>
        </div>
    </div>
</template>

<script>
import { isMobile } from '@/common/js/utils';

export default {

    mounted () {

        this.calLeft();
        window.addEventListener( 'resize', this.resizeHandle );
        $( '.select-shadow-area' ).on({
            'touchmove' ( e ) {

                e.preventDefault();

            }
        });

    },

    destroyed () {

        window.removeEventListener( 'resize', this.resizeHandle );

    },

    props: {

        options: {

            type: Array,
            required: true

        },
        value: {

            type: String,
            default: ''

        }

    },

    data () {

        return {

            selectedValue: this.value,
            clientWidth: document.body.clientWidth,
            left: '50%',
            textBottom: 0,
            showArea: false

        };

    },

    methods: {

        updateValue ( option ) {

            this.$emit( 'input', option.value );

        },

        resizeHandle () {

            this.clientWidth = document.body.clientWidth;
            this.calLeft();

        },

        calLeft () {

            let clientWidth = this.clientWidth;
            let select = $( this.$refs.select );
            let currentText = select.find( '.reo-select-inner' );
            let textLeft = currentText.offset().left;
            let textHeight = currentText[ 0 ].offsetHeight;
            this.textBottom = currentText.offset().top + textHeight;
            if ( clientWidth <= 1199 ) {

                this.left = `${-textLeft}px`;

            } else {

                this.left = `50%`;

            }

        }

    },

    watch: {

        value ( value ) {

            this.selectedValue = value;

        },
        showArea ( showArea ) {

            if ( showArea ) {

                $( 'html' ).css( 'overflow-y', 'hidden' );
                if ( !isMobile()) {

                    $( 'html' ).addClass( 'scroll-bar-hide' );
                
                }

            } else {

                $( 'html' ).css( 'overflow-y', 'auto' );
                $( 'html' ).removeClass( 'scroll-bar-hide' );

            }

        },
        selectedValue ( selectedValue ) {

            this.showArea = false;

        }

    },

    computed: {

        selectedLabel () {

            let options = this.options;
            let value = this.value;
            if ( options.length === 0 ) {

                return '';

            }
            for ( let option of options ) {

                if ( option.value === value ) {

                    return option.label;

                }

            }
            return '';

        },

        width () {

            let clientWidth = this.clientWidth;
            return clientWidth > 1199 ? '2.6rem' : `${clientWidth}px`;

        }

    }

};
</script>

<style lang="less">
    .reo-select{
        width: 1.8rem;
        display: inline-block;
        vertical-align: top;
    }

    .reo-select .ui-icon{
        font-size: 0.12rem;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%) scale(0.7);
    }

    .reo-select-inner>span{
        max-width: 100%;
        box-sizing: border-box;
        position: relative;
        padding-right: 0.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
    }

    .reo-select .reo-select-inner{
        border: none;
        outline: none;
        background-color: #F3F4F9;
        line-height: .8rem;
        height: 0.8rem;
        font-weight: 500;
        font-size: .16rem;
        text-align: center;
        cursor: pointer;
        width: 1.8rem;
        white-space: nowrap;
        width: 100%;
        box-sizing: border-box;
        padding: 0 15px;
    }

    .reo-select .reo-select-inner.hover{
        color: @theme;
    }

    .reo-select-option{
        overflow-y: auto;
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
        background-color: #fff;
        width: 1.8rem;
        text-align: center;
        min-height: .5rem;
        max-height: 2.5rem;
        border: 1px solid #fff;
        box-sizing: border-box;
    }

    .reo-select .reo-select-wrap{
        z-index: 99;
        position: absolute;
    }

    .reo-select .reo-select-option li{
        line-height: 20px;
        padding: 15px;
        color: #666;
        font-size: .16rem;
        font-weight: 500;
        cursor: pointer;
        position: relative;
    }

    .reo-select .reo-select-option li.active{
        color: @theme;
    }
    .reo-select .reo-select-option li:hover{
        background-color: #F7F7F7;
        color: @theme;
    }

    @media screen and (max-width:1199px) {
        .reo-select .reo-select-inner{
            font-size: 0.26rem;
        }
        .reo-select .ui-icon{
            font-size: 0.15rem;
        }
        .reo-select-inner>span{
            padding-right: 0.25rem;
        }
        .reo-select .reo-select-wrap{
            box-shadow: 0 0.16rem 0.6rem rgba(0,0,0,0.12);
        }
    }

    .select-shadow-area{
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0,0,0,0);
        z-index: -1;
        display: none;
    }

    .reo-select-inner .ui-gradient-blue{
        display: none;
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
    }

    .reo-select-status{
        display: block;
        width: 6px;
        height: 6px;
        border-radius: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 15px;
    }

    .reo-select-status.success{
        background-color: @theme;
    }

    .reo-select-status.warn{
        background-color: #e96900;
    }

    .reo-select-status.fail{
        background-color: #ccc;
    }

    @media screen and (max-width:1199px){
        .select-shadow-area{
            display: block;
        }
        .reo-select-inner.hover .ui-gradient-blue{
            display: block;
        }
        .reo-select-wrap .ui-gradient-blue{
            display: none;
        }
        .reo-select{
            width: 100%;
        }
        .reo-select .reo-select-option li{
            height: 0.88rem;
            font-size: 0.26rem;
            line-height: 0.88rem;
            padding: 0;
        }
        .reo-select-option{
            max-height: 4.4rem;
            min-height: 0.88rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/basic/Select.vue